import React from 'react';
import classnames from 'classnames';
import Button from '../Button';
import * as styles from './PageBlocks.module.styl';

function HeroTitle({ title1, title2 }) {
  if (!title1 && !title2) return null;
  return (
    <h1 className="text-4xl lg:text-5xl lg:leading-[1.15]">
      {title1 || null}
      {title1 && title2 ? <br /> : null}
      {title2 || null}
    </h1>
  );
}

export default function ProductHero({
  title_1 = '',
  title_2 = '',
  description,
  video,
  poster,
  image,
  video_controls = false,
  image_border = true,
  aspect_ratio = '1',
  link,
  terms,
  bgColor,
  textColor,
  bgImage,
}) {
  const textStyles =
    textColor && textColor.includes('--text-dark') && bgImage
      ? {
          color: textColor,
          //mixBlendMode: 'difference',
        }
      : { color: textColor };

  const videoIsYouTube = video?.includes('youtube.com');
  const extractYouTubeId = (url) => {
    const regExp =
      /^.*((youtu\.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[7].length === 11 ? match[7] : false;
  };
  const videoId = videoIsYouTube ? extractYouTubeId(video) : video;

  return (
    <div>
      <div
        className={classnames(
          styles.productHero,
          `pb-12 bg-left bg-fixed bg-cover bg-top xl:bg-right`,
        )}
        style={{
          backgroundImage: bgImage ? `url(${bgImage})` : 'none',
          backgroundColor: bgColor,
        }}
      >
        <div className="lg:min-h-[calc(100vh-50px)] 3xl:h-[900px] lg:max-h-[1024px] max-width !px-[50px] lg:grid lg:grid-cols-2 items-center">
          <div className="lg:p-[50px] lg:py-[140px] pt-[140px] flex-1 relative">
            <span style={textStyles}>
              <HeroTitle title1={title_1} title2={title_2} />
              {description ? (
                <p className="max-w-full lg:mt-8 lg:w-[400px]">{description}</p>
              ) : null}
            </span>
            {link?.link_url && link?.link_text ? (
              <>
                <div className="hidden lg:block">
                  <Button yellow solid href={link.link_url}>
                    {link.link_text}
                  </Button>
                </div>
                <div className="lg:hidden">
                  <Button black solid xl href={link.link_url}>
                    {link.link_text}
                  </Button>
                </div>
              </>
            ) : null}

            {terms ? (
              <p style={textStyles} className="text-xs opacity-50 my-3">
                {terms}
              </p>
            ) : null}
          </div>
          {video && !videoIsYouTube ? (
            <div className="flex items-center justify-center py-6 lg:pt-24">
              <video
                autoPlay
                loop
                muted
                controls={!!video_controls}
                disableRemotePlayback="true"
                poster={poster || ''}
                playsInline
                style={{ aspectRatio: aspect_ratio }}
                className={`w-full max-w-full lg:w-[850px] lg:ml-[-50px]  lg:max-w-[100%]  xl:max-w-[45vw] ${
                  image_border
                    ? 'bg-white outline outline-[10px] outline-white'
                    : ''
                } lozad rounded-3xl`}
              >
                <source data-src={video} />
              </video>
            </div>
          ) : null}

          {videoIsYouTube ? (
            <div className="flex items-center justify-center py-6 lg:pt-24">
              <iframe
                src={`https://www.youtube.com/embed/${videoId}?controls=1&showinfo=0&rel=0&modestbranding=1&playlist=${videoId}`}
                title="YouTube Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full max-w-full aspect-video bg-cover rounded-3xl lg:w-[750px] lg:max-w-[70vh]"
              />
            </div>
          ) : null}

          {image ? (
            <div className="flex items-center justify-center py-6 lg:pt-24">
              <div
                className={`w-full max-w-full bg-cover lg:w-[650px] lg:max-w-[70vh] ${
                  image_border ? 'bg-white border-[10px] border-white' : ''
                } lozad rounded-3xl`}
                style={{
                  aspectRatio: aspect_ratio,
                  backgroundImage: `url(${image})`,
                }}
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
